import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import Navbar from '@/components/landing/Navbar';
import Footer from '@/components/landing/Footer';
import { useLanguage } from '@/context/LanguageContext';

const PaymentCancelPage = () => {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="payment-cancel-page">
      <Navbar />
      <main className="vf-section">
        <div className="vf-container max-w-xl mx-auto text-center py-20">
          <h2 className="text-3xl font-bold text-[#1e3a5f] mb-3">{t('pay_cancelled') || 'Payment Cancelled'}</h2>
          <p className="text-slate-500 mb-8">{t('pay_cancelled_desc') || 'No charges were made. You can try again anytime.'}</p>
          <Link to={`/${language}/pricing`} className="vf-btn-primary inline-flex items-center gap-2" data-testid="back-to-pricing">
            <ArrowLeft className="w-5 h-5" /> {t('pay_back_pricing') || 'Back to Pricing'}
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentCancelPage;
